// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"a1475e25","114":"13ff1084","240":"6251f4a1","540":"423392c1","624":"59f0c59a"}[chunkId] + ".chunk.js";
};